import axios from 'axios'
import { setConnectionError } from '../state/error'
import { loadingOff } from '../state/navigation'
import store from '../state/store.js'
import { requestWithUserAuth } from './auth'

export function fetchVirtualBadge (config, auth, onSuccess, onError) {
  requestWithUserAuth(config, auth, (authTokens) => {
    const { publicBackendUrl, apiUri } = config
    const url = `${publicBackendUrl}/${apiUri}/user/virtual-badge`
    axios
      .get(url, {
        headers: { Authorization: authTokens.accessToken },
        responseType: 'blob'
      })
      .then((response) => {
        store.dispatch(setConnectionError({ error: false }))
        store.dispatch(loadingOff())
        onSuccess(response)
      })
      .catch((error) => {
        const { message, code } = error
        const response = error?.response
        let detail = response?.data ?? message
        if (typeof Blob !== 'undefined' && detail instanceof Blob) {
          const statusText = response?.statusText ? ` ${response.statusText}` : ''
          detail = response?.status
            ? `Request failed (${response.status}${statusText})`
            : message
        }
        store.dispatch(setConnectionError({ error: true, detail, message, code }))
        store.dispatch(loadingOff())
        onError(error)
      })
  })
}
